import React from 'react';
import { Link } from 'react-router-dom';

interface PaginationProps {
  next: () => void;
  previous: () => void;
  page: number;
}

export function Pagination2({ next, previous, page }: PaginationProps): JSX.Element {
  return (
    <div className="g">
      <ul className="pagination justify-content-center justify-content-md-start">
        <li className="page-item">
          <Link className="page-link" to="#" onClick={previous}>
            <em className="icon ni ni-chevrons-left" />
            Anterior
          </Link>
        </li>

        <li className="page-item">
          <Link className="page-link" to="#">
            {page}
          </Link>
        </li>

        <li className="page-item">
          <Link className="page-link" to="#" onClick={next}>
            Próximo
            <em className="icon ni ni-chevrons-right" />
          </Link>
        </li>
      </ul>
    </div>
  );
}
